
import { EscortProfile } from '@/types';

export const generateMockProfiles = (isEmergency = false): EscortProfile[] => {
  if (isEmergency) {
    return [
      {
        id: 'mock-error-1',
        userId: 'mock-user-err-1',
        displayName: 'Emma (Mode Secours)',
        age: 24,
        bio: {
          short: 'Profil de secours - erreur de chargement',
          full: 'Ce profil s\'affiche car une erreur s\'est produite lors du chargement des profils réels.'
        },
        location: {
          city: 'Paris',
          country: 'France',
          latitude: 48.8566,
          longitude: 2.3522
        },
        attributes: {
          gender: 'female',
          height: 165,
          weight: 55,
          bodyType: 'slim',
          hairColor: 'black',
          eyeColor: 'brown',
          ethnicity: 'caucasian',
          nationality: 'French',
          measurements: '88-60-90',
          cupSize: 'B',
          intimateArea: 'shaved',
          tattoos: false,
          piercings: false,
          smoking: 'no',
          drinking: 'occasionally',
          sexualOrientation: 'bisexual',
          languages: ['French', 'English']
        },
        services: [
          { name: 'companionship', description: 'Événements et soirées', visibility: 'public' }
        ],
        rates: [
          { 
            id: 'mock-rate-err-1', 
            category: 'incall',
            description: '1 hour', 
            price: 250, 
            currency: 'EUR', 
            duration: '60', 
            visibility: 'public' 
          }
        ],
        isVerified: true,
        isOnline: true,
        isTouring: false,
        tourDates: []
      }
    ];
  }

  return [
    {
      id: 'mock-1',
      userId: 'mock-user-1',
      displayName: 'Sophie',
      age: 28,
      bio: {
        short: 'Élégante et sophistiquée',
        full: 'Je suis une escort élégante et sophistiquée à la recherche de compagnie agréable.'
      },
      location: {
        city: 'Paris',
        country: 'France',
        latitude: 48.8566,
        longitude: 2.3522
      },
      attributes: {
        gender: 'female',
        height: 168,
        weight: 58,
        bodyType: 'slim',
        hairColor: 'blonde',
        eyeColor: 'blue',
        ethnicity: 'caucasian',
        nationality: 'French',
        measurements: '90-60-90',
        cupSize: 'C',
        intimateArea: 'shaved',
        tattoos: false,
        piercings: true,
        smoking: 'no',
        drinking: 'occasionally',
        sexualOrientation: 'bisexual',
        languages: ['French', 'English']
      },
      services: [
        { name: 'companionship', description: 'Dîners et événements', visibility: 'public' },
        { name: 'massage', description: 'Massage sensuel', visibility: 'teaser' }
      ],
      rates: [
        { description: '1 hour', price: 300, currency: 'EUR', duration: '60', visibility: 'public' },
        { description: 'Overnight', price: 1500, currency: 'EUR', duration: '720', visibility: 'teaser' }
      ],
      isVerified: true,
      isOnline: true,
      isTouring: false,
      tourDates: []
    },
    {
      id: 'mock-2',
      userId: 'mock-user-2',
      displayName: 'Isabelle',
      age: 25,
      bio: {
        short: 'Passionnée et aventureuse',
        full: 'Je suis passionnée, aventureuse et toujours prête à vivre de nouvelles expériences.'
      },
      location: {
        city: 'Lyon',
        country: 'France',
        latitude: 45.7640,
        longitude: 4.8357
      },
      attributes: {
        gender: 'female',
        height: 170,
        weight: 62,
        bodyType: 'athletic',
        hairColor: 'brown',
        eyeColor: 'green',
        ethnicity: 'caucasian',
        nationality: 'French',
        measurements: '85-64-89',
        cupSize: 'B',
        intimateArea: 'natural',
        tattoos: true,
        piercings: true,
        smoking: 'no',
        drinking: 'occasionally',
        sexualOrientation: 'straight',
        languages: ['French', 'Spanish']
      },
      services: [
        { name: 'companionship', description: 'Soirées et voyages', visibility: 'public' }
      ],
      rates: [
        { 
          id: 'mock-rate-1', 
          category: 'incall',
          description: '1 hour', 
          price: 300, 
          currency: 'EUR', 
          duration: '60', 
          visibility: 'public' 
        },
        { 
          id: 'mock-rate-2',
          category: 'outcall',
          description: 'Overnight', 
          price: 1500, 
          currency: 'EUR', 
          duration: '720', 
          visibility: 'teaser' 
        }
      ],
      isVerified: true,
      isOnline: false,
      isTouring: false,
      tourDates: []
    }
  ];
};
